import { convertDatesToISO, getHeaders } from '@/config/aux'
import { SensorInjection } from '../models/sensorInjection'
import { SensorInjectionStateType } from './state'
import axios from 'axios'

export interface SensorInjectionActionsType {
  getSensorInjections(): Promise<void>
  getSensorInjectionsBySensorSettingId(sensorSettingId: string): Promise<void>
  getSensorInjectionsByType(type: string): Promise<void>
  getSensorInjectionsByCommandType(commandType: string): Promise<void>
  getActiveSensorInjections(): Promise<void>
  getReliableSensorInjections(): Promise<void>
  postSensorInjection(sensorInjection: SensorInjection): Promise<void>
  putSensorInjection(sensorInjection: SensorInjection): Promise<void>
  deleteSensorInjection(id: string): Promise<void>
  executeSensorInjection(id: string, payload?: any): Promise<void>
  toggleSensorInjectionStatus(id: string): Promise<void>
  testSensorInjection(id: string): Promise<void>
}

export const SensorInjectionActions = {
  async getSensorInjections(this: SensorInjectionStateType) {
    try {
      this.sensorInjections = []
      const query = `${process.env.VUE_APP_URL_BASE}/api/admin/sensor-injections`
      await axios.get(query, { headers: getHeaders() }).then(response => {
        if (response.status === 200) {
          response.data.forEach((sensorInjection: SensorInjection) => {
            this.sensorInjections.push(new SensorInjection(sensorInjection))
          })
        }
      })
    } catch (error) {
      console.error('Error getting SensorInjections', error)
    }
  },
  async getSensorInjectionsBySensorSettingId(this: SensorInjectionStateType, sensorSettingId: string) {
    try {
      this.sensorInjections = []
      const query = `${process.env.VUE_APP_URL_BASE}/api/admin/sensor-injections/sensor-setting/${sensorSettingId}`
      await axios.get(query, { headers: getHeaders() }).then(response => {
        if (response.status === 200) {
          response.data.forEach((sensorInjection: SensorInjection) => {
            this.sensorInjections.push(new SensorInjection(sensorInjection))
          })
        }
      })
    } catch (error) {
      console.error('Error getting SensorInjections by sensorSettingId', error)
    }
  },
  async getSensorInjectionsByType(this: SensorInjectionStateType, type: string) {
    try {
      this.sensorInjections = []
      const query = `${process.env.VUE_APP_URL_BASE}/api/admin/sensor-injections/type/${type}`
      await axios.get(query, { headers: getHeaders() }).then(response => {
        if (response.status === 200) {
          response.data.forEach((sensorInjection: SensorInjection) => {
            this.sensorInjections.push(new SensorInjection(sensorInjection))
          })
        }
      })
    } catch (error) {
      console.error('Error getting SensorInjections by type', error)
    }
  },
  async getSensorInjectionsByCommandType(this: SensorInjectionStateType, commandType: string) {
    try {
      this.sensorInjections = []
      const query = `${process.env.VUE_APP_URL_BASE}/api/admin/sensor-injections/command-type/${commandType}`
      await axios.get(query, { headers: getHeaders() }).then(response => {
        if (response.status === 200) {
          response.data.forEach((sensorInjection: SensorInjection) => {
            this.sensorInjections.push(new SensorInjection(sensorInjection))
          })
        }
      })
    } catch (error) {
      console.error('Error getting SensorInjections by commandType', error)
    }
  },
  async getActiveSensorInjections(this: SensorInjectionStateType) {
    try {
      this.sensorInjections = []
      const query = `${process.env.VUE_APP_URL_BASE}/api/admin/sensor-injections/active`
      await axios.get(query, { headers: getHeaders() }).then(response => {
        if (response.status === 200) {
          response.data.forEach((sensorInjection: SensorInjection) => {
            this.sensorInjections.push(new SensorInjection(sensorInjection))
          })
        }
      })
    } catch (error) {
      console.error('Error getting active SensorInjections', error)
    }
  },
  async getReliableSensorInjections(this: SensorInjectionStateType) {
    try {
      this.sensorInjections = []
      const query = `${process.env.VUE_APP_URL_BASE}/api/admin/sensor-injections/reliable`
      await axios.get(query, { headers: getHeaders() }).then(response => {
        if (response.status === 200) {
          response.data.forEach((sensorInjection: SensorInjection) => {
            this.sensorInjections.push(new SensorInjection(sensorInjection))
          })
        }
      })
    } catch (error) {
      console.error('Error getting reliable SensorInjections', error)
    }
  },
  async postSensorInjection(this: SensorInjectionStateType, sensorInjection: SensorInjection) {
    try {
      const query = `${process.env.VUE_APP_URL_BASE}/api/admin/sensor-injections`
      const data = convertDatesToISO(sensorInjection.toPlainObject())

      await axios.post(query, data, { headers: getHeaders() }).then(response => {
        if (response.status === 201) {
          // this.sensorInjections.push(sensorInjection)
        }
      })
    } catch (error) {
      console.error('Error posting SensorInjection', error)
    }
  },
  async putSensorInjection(this: SensorInjectionStateType, sensorInjection: SensorInjection) {
    try {
      const query = `${process.env.VUE_APP_URL_BASE}/api/admin/sensor-injections`
      const data = convertDatesToISO(sensorInjection.toPlainObject())

      await axios
        .put(query, data, {
          headers: {
            ...getHeaders(),
            'Content-Type': 'application/json',
          },
        })
        .then(response => {
          if (response.status === 200) {
            //this.sensorInjections = this.sensorInjections.map(si => (si.id === sensorInjection.id ? sensorInjection : si))
          }
        })
    } catch (error) {
      console.error('Error updating SensorInjection', error)
    }
  },
  async deleteSensorInjection(this: SensorInjectionStateType, id: string) {
    try {
      const query = `${process.env.VUE_APP_URL_BASE}/api/admin/sensor-injections/${id}`
      await axios.delete(query, { headers: getHeaders() }).then(response => {
        if (response.status === 200) {
          //this.sensorInjections = this.sensorInjections.filter(si => si.id !== id)
        }
      })
    } catch (error) {
      console.error('Error deleting SensorInjection', error)
    }
  },
  async executeSensorInjection(this: SensorInjectionStateType, id: string, payload?: any) {
    try {
      const query = `${process.env.VUE_APP_URL_BASE}/api/admin/sensor-injections/${id}/execute`
      const data = payload || {}

      await axios.post(query, data, { headers: getHeaders() }).then(response => {
        if (response.status === 200) {
          // Operación ejecutada exitosamente
        }
      })
    } catch (error) {
      console.error('Error executing SensorInjection', error)
    }
  },
  async toggleSensorInjectionStatus(this: SensorInjectionStateType, id: string) {
    try {
      const query = `${process.env.VUE_APP_URL_BASE}/api/admin/sensor-injections/${id}/toggle`
      await axios.post(query, {}, { headers: getHeaders() }).then(response => {
        if (response.status === 200) {
          // Actualizar estado activo en el store local
          // this.getSensorInjections()
        }
      })
    } catch (error) {
      console.error('Error toggling SensorInjection status', error)
    }
  },
  async testSensorInjection(this: SensorInjectionStateType, id: string) {
    try {
      const query = `${process.env.VUE_APP_URL_BASE}/api/admin/sensor-injections/${id}/test`
      await axios.post(query, {}, { headers: getHeaders() }).then(response => {
        if (response.status === 200) {
          // Test ejecutado exitosamente
        }
      })
    } catch (error) {
      console.error('Error testing SensorInjection', error)
    }
  },
}
